import { render, staticRenderFns } from "./new-request.vue?vue&type=template&id=36d1178d&scoped=true"
import script from "./new-request.vue?vue&type=script&lang=js"
export * from "./new-request.vue?vue&type=script&lang=js"
import style0 from "./new-request.vue?vue&type=style&index=0&id=36d1178d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1178d",
  null
  
)

export default component.exports